import { Box, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { Button, ExternalLink } from '../../../components';
import { CodeBlock } from '../code-block';
import { handleCopyClick } from '../constants';
import { StyleGuidePage } from '../style-guide-page';

export const StyleGuideButtons = () => {
  const [isCopied, setIsCopied] = useState<{
    [val: string]: boolean;
  }>({});

  return (
    <StyleGuidePage title="Buttons">
      <Grid container mb={3}>
        <Grid item xs={12} lg={8}>
          <Typography mb={1}>
            The button component is built upon the{' '}
            <ExternalLink
              to="https://mui.com/material-ui/react-button/#basic-button"
              target="_blank"
            >
              MUI Button
            </ExternalLink>{' '}
            component. At the time, the Loading Button was an experiment and there was a separate
            need to use React Router Dom's Link component for a button. As such, the custom button
            component was created. This button component also supports <em>forwardRef</em>.
          </Typography>
          <Typography mb={1}>
            <strong>In most cases, the MUI Button will suffice.</strong> SMB uses the{' '}
            <em>contained</em> variant for buttons. The most common colors for buttons used are{' '}
            <em>primary</em>, <em>secondary</em>, and <em>inherit</em>.
          </Typography>
          <code>
            Props:
            <br />- ButtonProps
            <br />- id: string <br />- loading?: JSX.Element | string
            <br />- LoaderProps?: ILoaderProps
            <br />- target?: string
            <br />- rel?: string
            <br />- asLink?: boolean
            <br />- to?: string
          </code>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Box mb={1}>
            <Button id="test-button-1" color="primary" variant="contained" asLink to="/">
              Button
            </Button>
          </Box>
          <CodeBlock handleCopyClick={e => handleCopyClick(setIsCopied, e)} isCopied={isCopied}>
            &lt;Button id="test-button-1" color="primary" variant="contained" asLink to="/"&gt;{' '}
            <br />
            &nbsp;&nbsp;&nbsp;Button <br />
            &lt;/Button&gt;
          </CodeBlock>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box mb={1}>
            <Button id="test-button-2" color="secondary" variant="contained" asLink to="/">
              Button
            </Button>
          </Box>

          <CodeBlock handleCopyClick={e => handleCopyClick(setIsCopied, e)} isCopied={isCopied}>
            &lt;Button id="test-button-2" color="secondary" variant="contained" asLink to="/"&gt;{' '}
            <br />
            &nbsp;&nbsp;&nbsp;Button <br />
            &lt;/Button&gt;
          </CodeBlock>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box mb={1}>
            <Button id="test-button-3" color="inherit" variant="contained" asLink to="/">
              Button
            </Button>
          </Box>
          <CodeBlock handleCopyClick={e => handleCopyClick(setIsCopied, e)} isCopied={isCopied}>
            &lt;Button id="test-button-3" color="inherit" variant="contained" asLink to="/"&gt;{' '}
            <br />
            &nbsp;&nbsp;&nbsp;Button <br />
            &lt;/Button&gt;
          </CodeBlock>
        </Grid>
      </Grid>
    </StyleGuidePage>
  );
};
